import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GknRouteLabel, GknRoutePath } from 'src/app/app-routing.enum';
import { HomeSearchCtaBannerCardComponent } from './home-search-cta-banner-card/home-search-cta-banner-card.component';
import { HomeSearchCtaBannerInputComponent } from './home-search-cta-banner-input/home-search-cta-banner-input.component';
import { HomeSearchCtaBannerCard } from './home-search-cta-banner.interface';
import { ResponsiveContainerComponent } from '@shared/components/responsive-container/responsive-container.component';

@Component({
    selector: 'app-home-search-cta-banner',
    imports: [
        CommonModule,
        ResponsiveContainerComponent,
        FormsModule,
        HomeSearchCtaBannerCardComponent,
        HomeSearchCtaBannerInputComponent,
        MatCardModule,
        MatIconModule,
        MatFormFieldModule,
        MatTooltipModule,
        ReactiveFormsModule,
    ],
    templateUrl: './home-search-cta-banner.component.html',
    styleUrls: ['./home-search-cta-banner.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HomeSearchCtaBannerComponent {
    /**
     * slides of cards.
     * order matters
     */
    cards: HomeSearchCtaBannerCard[] = [
        {
            props: {
                label: GknRouteLabel.EDUCATION,
                svgIcon: 'education',
                imagePath: 'assets/images/program-images/isometric-with-spotlight/education.png',
                description:
                    'Advance your skills with specialized trainings, in-depth resources, and expert guidance designed to support you at every stage of your journey.',
                route: GknRoutePath.EDUCATION,
                dataAnalytics: ['home', 'cta', 'education'],
            },
        },
        {
            props: {
                label: GknRouteLabel.COMMUNITY,
                svgIcon: 'community',
                imagePath: 'assets/images/program-images/isometric-with-spotlight/community.png',
                description:
                    'Connect with fellow orchestrators in a collaborative space to share ideas, celebrate milestones, and find support every step of the way.',
                route: GknRoutePath.COMMUNITY,
                dataAnalytics: ['home', 'cta', 'community'],
            },
        },
        {
            props: {
                label: GknRouteLabel.ADVOCACY,
                svgIcon: 'advocacy',
                imagePath: 'assets/images/program-images/isometric-with-spotlight/advocacy.png',
                description:
                    'Champion the orchestrator spirit by amplifying your voice, sharing successes, and inspiring others to embrace the power of orchestration.',
                route: GknRoutePath.ADVOCACY,
                dataAnalytics: ['home', 'cta', 'advocacy'],
            },
        },
        {
            props: {
                label: GknRouteLabel.SUPPORT,
                svgIcon: 'support',
                imagePath: 'assets/images/program-images/isometric-with-spotlight/support.png',
                description:
                    'Get the support you need with our global support team, available 24/7 to handle any issue.',
                route: GknRoutePath.SUPPORT,
                dataAnalytics: ['home', 'cta', 'support'],
            },
        },
        {
            props: {
                label: GknRouteLabel.RESOURCES,
                svgIcon: 'resources',
                imagePath: 'assets/images/program-images/isometric-with-spotlight/resources.png',
                description: `Explore tools, guides, and helpful content to support your journey—whether you're getting started or looking to dive deeper.`,
                route: GknRoutePath.RESOURCES,
                dataAnalytics: ['home', 'cta', 'resources'],
            },
        },
    ];
}
